export const SET_SELECTED_CARD_REQUEST_ID = 'SET_SELECTED_CARD_REQUEST_ID';

export class SetSelectedCardRequestId {
  readonly type = SET_SELECTED_CARD_REQUEST_ID;

  constructor(public payload: string) {}
}

export type CardRequestsActions = SetSelectedCardRequestId;
